import styled from 'root/src/client/web/base/StaticLayout/style'
import { linkHoverColor, linkColor } from 'root/src/client/web/commonStyles'

const styles = {
	listWrapper: {
		marginTop: -50,
		padding: 30,
	},
	listOfLinks: {
		...styled.list,
		fontSize: 14,
		paddingLeft: 20,

		'& li': {
			marginBottom: 5,
			cursor: 'pointer',
		},
		'& a': {
			color: linkColor,
			textDecoration: 'none',
			'&:hover': {
				color: linkHoverColor,
			},
		},
	},
	list: {
		...styled.list,
		fontSize: 14,
		lineHeight: '22px',
		paddingLeft: 45,
		'& li': {
			marginBottom: 12,
		},
	},
	section: {
		...styled.section,
		lineHeight: '24px',
		'& p': {
			lineHeight: '24px',
			'@media (max-width: 375px)': {
				fontSize: 14,
			},
		},
		'& strong': {
			display: 'block',
		},
		marginBottom: 30,
	},
	sectionTitle: {
		...styled.sectionTitle,
		fontSize: 20,
		marginBottom: 18,
		marginTop: 18,
	},
	banner: {
		marginBottom: -30,
	},
	footer: {
		width: 222,
		margin: '0 auto',
		paddingTop: 30,
		paddingBottom: 0,
		textAlign: 'center',
		'@media (max-width: 600px)': {
			paddingTop: 6,
			paddingBottom: 0,
		},
		'@media (max-width: 375px)': {
			paddingTop: 6,
			paddingBottom: 0,
		},
	},
	marketplace: {
		fontWeight: 700,
		textDecoration: 'underline',
		'& a': {
			color: linkColor,
			'&:hover': {
				color: linkHoverColor,
			},
		},
	},
}

export default styles
